"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvisionerTaskType = exports.ProvisionerTaskStatus = void 0;
var ProvisionerTaskStatus;
(function (ProvisionerTaskStatus) {
    ProvisionerTaskStatus["Pending"] = "pending";
    ProvisionerTaskStatus["Delayed"] = "delayed";
    ProvisionerTaskStatus["Started"] = "started";
    ProvisionerTaskStatus["Success"] = "success";
    ProvisionerTaskStatus["Failure"] = "failure";
    ProvisionerTaskStatus["Timeout"] = "timeout";
})(ProvisionerTaskStatus = exports.ProvisionerTaskStatus || (exports.ProvisionerTaskStatus = {}));
var ProvisionerTaskType;
(function (ProvisionerTaskType) {
    ProvisionerTaskType["SolutionInstaller"] = "SolutionInstaller";
    ProvisionerTaskType["LicenseUpdater"] = "LicenseUpdater";
    ProvisionerTaskType["SupportBundler"] = "SupportBundler";
    ProvisionerTaskType["IdpQuery"] = "IdpQuery";
    ProvisionerTaskType["IdpUpdater"] = "IdpUpdater";
    ProvisionerTaskType["CognitoUserChange"] = "CognitoUserChange";
    ProvisionerTaskType["PrivilegeQuery"] = "PrivilegeQuery";
    ProvisionerTaskType["PrivilegeUpdater"] = "PrivilegeUpdater";
    ProvisionerTaskType["OverrideLogLevel"] = "OverrideLogLevel";
    ProvisionerTaskType["ResetCognitoPassword"] = "ResetCognitoPassword";
    ProvisionerTaskType["DeleteCognitoUser"] = "DeleteCognitoUser";
})(ProvisionerTaskType = exports.ProvisionerTaskType || (exports.ProvisionerTaskType = {}));
//# sourceMappingURL=ProvisionerTasks.js.map